export default "__VITE_ASSET__M0o7P80d__"